import React from 'react';
import { Box, Typography } from '@mui/material';

import { formatPrice } from '../../lib/money';
import { COLORS, FONT_BODY } from './storefrontStyles';

const PriceTag = ({ price, compareAtPrice, size = 'small' }) => {
    const big = size === 'large';
    const showCompare =
        compareAtPrice !== null &&
        compareAtPrice !== undefined &&
        Number(compareAtPrice) > Number(price);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'baseline',
                gap: 1,
                flexWrap: 'wrap',
            }}
        >
            <Typography
                component="span"
                sx={{
                    color: COLORS.text,
                    fontFamily: FONT_BODY,
                    fontWeight: 600,
                    fontSize: big ? { xs: '1.6rem', md: '2rem' } : '0.95rem',
                }}
            >
                {formatPrice(price)}
            </Typography>
            {showCompare && (
                <Typography
                    component="span"
                    sx={{
                        color: COLORS.subtle,
                        fontFamily: FONT_BODY,
                        textDecoration: 'line-through',
                        fontSize: big ? '1.1rem' : '0.8rem',
                    }}
                >
                    {formatPrice(compareAtPrice)}
                </Typography>
            )}
        </Box>
    );
};

export default PriceTag;
